import React from "react";
import './styles/covid.css';

const CovidFAQ = () => {
  const faqs = [
    {
      question: "Where can I get tested for COVID-19?",
      answer:
        "COVID-19 testing facilities are available across Minnesota. To find the nearest location, visit the MN COVID-19 Testing Locations webpage. Availability may change daily based on demand and supply.",
    },
    {
      question: "How do I get tested?",
      answer:
        "Testing procedures vary by location. Some sites offer drive-through testing, while others require appointments and pre-screening before entering. Check the specific instructions on the testing location’s website.",
    },
    {
      question: "Is COVID-19 testing free?",
      answer:
        "Federal law mandates health insurance providers to cover COVID-19 diagnostic and antibody testing at no cost. Public health programs in Minnesota, such as Medical Assistance and MinnesotaCare, have also waived associated costs.",
    },
    {
      question: "How fast can I receive my test results?",
      answer:
        "The speed of test results depends on the volume of testing and the system’s capacity. Some tests are processed in-house within hours, while others may be sent to external labs, leading to delays of a few days.",
    },
    {
      question: "Will my insurance cover COVID-19 testing and treatment?",
      answer:
        "Yes. Most health insurance plans cover medically necessary testing and treatment for COVID-19. Many companies have waived copays, deductibles, and coinsurance related to testing. Contact your insurer for details.",
    },
  ];

  return (
    <div className="container covid-faq py-5">
      <h2 className="text-center mb-4">Frequently Asked Questions About COVID-19 Testing</h2>

      <div className="row">
        {faqs.map((faq, index) => (
          <div key={index} className="col-md-6">
            <div className="card faq-card mb-4">
              <div className="card-body">
                <h5 className="question">{faq.question}</h5>
                <p className="answer">{faq.answer}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CovidFAQ;
